import bmpIcon from './images/bmp-icon.svg';
import bmpSimpleIcon from './images/bmp-simple-icon.svg';
import comIcon from './images/com-icon.svg';
import comSimpleIcon from './images/com-icon.svg';
import docxIcon from './images/docx-icon.svg';
import docxSimpleIcon from './images/docx-simple-icon.svg';
import dotxIcon from './images/dotx-icon.svg';
import dotxSimpleIcon from './images/dotx-simple-icon.svg';
import fileIcon from './images/file-icon.svg';
import fileSimpleIcon from './images/file-simple-icon.svg';
import gifIcon from './images/gif-icon.svg';
import gifSimpleIcon from './images/gif-simple-icon.svg';
import heicIcon from './images/heic-icon.svg';
import heicSimpleIcon from './images/heic-simple-icon.svg';
import htmlIcon from './images/html-icon.svg';
import htmlSimpleIcon from './images/html-simple-icon.svg';
import starIcon from './images/icon-star.svg';
import starSimpleIcon from './images/icon-star.svg';
import jpgIcon from './images/jpg-icon.svg';
import jpgSimpleIcon from './images/jpg-simple-icon.svg';
import movIcon from './images/mov-icon.svg';
import movSimpleIcon from './images/mov-simple-icon.svg';
import mp3Icon from './images/mp3-icon.svg';
import mp3SimpleIcon from './images/mp3-simple-icon.svg';
import mp4Icon from './images/mp4-icon.svg';
import mp4SimpleIcon from './images/mp4-simple-icon.svg';
import mpgIcon from './images/mpg-icon.svg';
import mpgSimpleIcon from './images/mpg-simple-icon.svg';
import ottIcon from './images/ott-icon.svg';
import ottSimpleIcon from './images/ott-simple-icon.svg';
import pdfIcon from './images/pdf-icon.svg';
import pdfSimpleIcon from './images/pdf-simple-icon.svg';
import pngIcon from './images/png-icon.svg';
import pngSimpleIcon from './images/png-simple-icon.svg';
import pptIcon from './images/ppt-icon.svg';
import pptSimpleIcon from './images/ppt-simple-icon.svg';
import xlsIcon from './images/xls-icon.svg';
import xlsSimpleIcon from './images/xls-simple-icon.svg';
import xlsxIcon from './images/xlsx-simple-icon.svg';
import xlsxSimpleIcon from './images/xlsx-simple-icon.svg';
import zipIcon from './images/zip-icon.svg';
import zipSimpleIcon from './images/zip-simple-icon.svg';
import iconCollectionNormalGreen from './images/icon-collection-green.svg';
import iconCollectionSelectedGreen from './images/icon-collection-selected-green.svg';
import iconCollectionSelectedRed from './images/icon-collection-solid-red.svg';

const Icons = {
  bmp: bmpIcon,
  com: comIcon,
  docx: docxIcon,
  dotx: dotxIcon,
  file: fileIcon,
  gif: gifIcon,
  heic: heicIcon,
  html: htmlIcon,
  star: starIcon,
  jpg: jpgIcon,
  mov: movIcon,
  mp3: mp3Icon,
  mp4: mp4Icon,
  mpg: mpgIcon,
  ott: ottIcon,
  pdf: pdfIcon,
  png: pngIcon,
  ppt: pptIcon,
  xls: xlsIcon,
  xlsx: xlsxIcon,
  zip: zipIcon
};

const SimpleIcons = {
  bmp: bmpSimpleIcon,
  com: comSimpleIcon,
  docx: docxSimpleIcon,
  dotx: dotxSimpleIcon,
  file: fileSimpleIcon,
  gif: gifSimpleIcon,
  heic: heicSimpleIcon,
  html: htmlSimpleIcon,
  star: starSimpleIcon,
  jpg: jpgSimpleIcon,
  mov: movSimpleIcon,
  mp3: mp3SimpleIcon,
  mp4: mp4SimpleIcon,
  mpg: mpgSimpleIcon,
  ott: ottSimpleIcon,
  pdf: pdfSimpleIcon,
  png: pngSimpleIcon,
  ppt: pptSimpleIcon,
  xls: xlsSimpleIcon,
  xlsx: xlsxSimpleIcon,
  zip: zipSimpleIcon
}

const getIconByName = (iconName) => {
  // console.log('iconName', iconName);
  if (Icons[iconName]) {
    return Icons[iconName]
  } else {
    return Icons['file']
  }
}

const getSimpleIconByName = (iconName) => {
  if (SimpleIcons[iconName]) {
    return SimpleIcons[iconName]
  } else {
    return SimpleIcons['file']
  }
}

export {
  Icons,
  SimpleIcons,
  getIconByName,
  getSimpleIconByName,
  iconCollectionNormalGreen,
  iconCollectionSelectedGreen,
  iconCollectionSelectedRed
};
